import { BaseApiService } from '@/services/base-service';
import {
  ApiPagination, BaseResponse, Filters, FiltersPagination,
} from '@/types';
import { RetroBonuses } from '../types';

interface RetroBonusesList extends BaseResponse, ApiPagination {
  data: {
    items: RetroBonuses.RetroBonus[],
    organizations: string[],
  }
}

interface RewardDocumentsList extends BaseResponse, ApiPagination {
  data: {
    items: RetroBonuses.RewardDocument[],
    scenarios: RetroBonuses.RetroScenarios[],
    contract: RetroBonuses.Contract,
  }
}

interface RewardDocumentProductsList extends BaseResponse, ApiPagination {
  data: {
    items: RetroBonuses.RewardDocumentProducts[],
  }
}

export class RetroBonusesService extends BaseApiService {
  private readonly base_path = 'retro-bonuses/contracts';

  async get_retro_bonuses(filters: FiltersPagination<Filters>): Promise<RetroBonusesList> {
    const payload = filters;

    const { data } = await this.http_client.get<RetroBonusesList>(this.base_path, {
      params: {
        filters: payload.filters,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  async get_rewards_documents_by_id(id: string | number, filters: FiltersPagination<Filters>): Promise<RewardDocumentsList> {
    const payload = filters;
    const url = `${this.base_path}/${id}/reward-documents`;

    const { data } = await this.http_client.get<RewardDocumentsList>(url, {
      params: {
        filters: payload.filters,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  async get_reward_document_by_id(id: string | number): Promise<RetroBonuses.RewardDocumentsDetail> {
    const url = `${this.base_path}/reward-documents/${id}`;
    const { data } = await this.http_client.get<RetroBonuses.RewardDocumentsDetail>(url);

    return data;
  }

  async get_reward_document_products_by_id(id: string | number, filters: FiltersPagination<Filters>): Promise<RewardDocumentProductsList> {
    const payload = filters;
    const url = `${this.base_path}/reward-documents/${id}/products`;

    const { data } = await this.http_client.get<RewardDocumentProductsList>(url, {
      params: {
        filters: payload.filters,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  // async get_retro_bonuses_by_id(id: string | number, filters: Filters): Promise<RetroBonusesDetailList> {
  //   const payload = filters;
  //   const url = `${this.base_path}/${id}`;

  //   const { data } = await this.http_client.get<RetroBonusesDetailList>(url, {
  //     params: {
  //       filters: payload.filters,
  //     },
  //   });

  //   return data;
  // }

  // async get_retro_bonuses_products_by_id(id: string | number, filters: FiltersPagination<Filters>): Promise<RetroBonusesProductsList> {
  //   const payload = filters;
  //   const url = `${this.base_path}/scenarios/${id}/products`;

  //   const { data } = await this.http_client.get<RetroBonusesProductsList>(url, {
  //     params: {
  //       filters: payload.filters,
  //       limit: payload.pagination.limit,
  //       page: payload.pagination.page,
  //       sort: payload.pagination.sort,
  //       sort_type: payload.pagination.sort_type,
  //     },
  //   });

  //   return data;
  // }
}
